<template>
    <div class="amount_card" :class="isActiveAmount ? 'active_card' : ''" @click="handleCardClick">
        R$ {{ props.amount }}
        <div v-if="isTopupVisible" class="topPercentage" :class="isActiveAmount ? 'activeLabel' : 'inactiveLabel'">
            <span class="item-span">{{ props.giftRatio }}%</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
    amount: {
        type: Number,
    },
    isActiveAmount: {
        type: Boolean,
        default: () => false
    },
    isTopupVisible: {
        type: Boolean,
        default: () => false
    },
    giftRatio: {
        type: Number,
    }
})
const emits = defineEmits(['handleCardClick'])

const handleCardClick = () => {
    emits('handleCardClick')
}

</script>
<style scoped>
.amount_card {
    position: relative;
    border-radius: 30px; 
    color: #ffffffa6;
    background-color: #291632;
    padding: 10px;
    width: 80%;
    text-align: center;
    font-size: 14px;
    overflow: hidden;
    transition: all .3s ease;
}

.active_card {
    font-weight: bold;
    border: 0px solid transparent;
    background-image: linear-gradient(90deg, #fa1ea9, #f380c6);
    color: #fff;
    border-radius: 30px;
}

.activeLabel {
    background: #f808a0;
    color: #000;
    font-weight: 600;
}

.inactiveLabel {
    background: rgba(0, 0, 0, 0.15);
    color: rgba(255, 255, 255, 0.85);
}

.topPercentage {
    position: absolute;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    width: 55px;
    height: 25px;
    top: 0;
    right: -20px;
    transform: rotate(45deg);
    font-size: 8px;
}

/* @media (min-width: 1440px) {
    .topPercentage {
        margin-left: 4.5vw !important;
    }
}

@media (min-width: 1920px) {
    .topPercentage {
        margin-left: 4.8vw !important;
    }
} */

.item-span {
    top: 10px;
    left: 1px;
}
</style>